if (!customElements.get('gift-wrapping')) {
  customElements.define('gift-wrapping', class GiftWrapping extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init () {
      this.giftWrappingBtn = this.querySelector('[js-gift-wrapping]');
      this.giftWrappingModal = document.querySelector('[js-gift-modal]');
      this.closeBtns = document.querySelectorAll('[js-close-btn]');
      this.giftErrorMessage = document.querySelector('[js-modal-error-message]');
      this.addToOrder = document.querySelector('.gift-wrapping-modal .add-to-order');
      this.giftNote = document.querySelector('.gift-wrapping-modal .gift-note textarea');

      this.title = this.getAttribute('data-gift-title');
      this.description = this.getAttribute('data-gift-description');
      this.variantId = this.getAttribute('data-variant-id');

      this.giftProduct = this.querySelector('#gift-product').innerHTML;
      this.giftErrorMessage.classList.remove('active');

      if (this.giftProduct) {
        this.giftProduct = JSON.parse(this.giftProduct);
      }

      if (this.giftWrappingBtn) {
        const input = this.giftWrappingBtn.querySelector('input');
        input.addEventListener('change', (e) => {
          e.preventDefault();

          let isChecked = e.target.checked;

          if (isChecked) {
            this.giftWrappingModal.classList.remove('hidden');
            this.renderGiftModal(this.giftProduct)
          } else {
            this.giftWrappingModal.classList.add('hidden');
          }
        });
      }

      this.closeBtns.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();

          this.giftWrappingModal.classList.add('hidden');
          this.giftErrorMessage.classList.remove('active');
          this.giftWrappingBtn.querySelector('input').checked = false;
        });
      });

      if (this.addToOrder) {
        this.addToOrder.addEventListener('click', (e) => {
          e.preventDefault();
          window.sessionStorage.setItem("variant_id", this.giftWrappingBtn.getAttribute('data-variant-id'));
          window.sessionStorage.setItem("gift_note", this.giftNote.value);

          this.giftWrappingModal.classList.add('hidden');
        });
      }
    }

    renderGiftModal (product) {
      if (product) {
        const title = product.title;
        const image = product.featured_image;
        const desc = product.description;

        const imgHtml = `
          <img src="${image}">
        `;

        const modalImage = document.querySelector('[js-product-image]');
        const modalTitle = document.querySelector('[js-product-title]');
        const modalDescription = document.querySelector('[js-product-description]')
        const modalBottomText = document.querySelector('[js-modal-bottom-text]');

        modalImage.innerHTML = imgHtml;

        if (this.title) {
          modalTitle.innerHTML = this.title;
        } else {
          modalTitle.innerHTML = title;
        }

        if (this.description) {
          modalDescription.innerHTML = this.description;
        } else {
          modalDescription.innerHTML = desc;
        }
        modalBottomText.innerHTML = this.querySelector('[js-gift-wrapping]').getAttribute('data-bottom-text');
      }
    }
  });
}
